import {combineReducers} from 'redux'
import lkReducer from './lk';

const rootReducer = combineReducers({
    lk: lkReducer
})

export default rootReducer;